import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentUser: {
      getUserToken () {
        return window.localStorage.getItem('currentUser_token')
      },
      getUserName () {
        return window.localStorage.getItem('currentUser_name')
      }
    }
  },
  getters: {
    getToken (state) {
      return state.currentUser.getUserToken()
    },
    getUserName (state) {
      return state.currentUser.getUserName()
    }
  },
  mutations: {
    setToken (state, ssoToken) {
      window.localStorage.setItem('currentUser_token', ssoToken)
    }
  },
  actions: {
  },
  modules: {
  }
})
